export default __webpack_public_path__ + "5218b90053e43b804ee46c34688a6280.svg";